
import React from 'react';
import { cn } from '@/lib/utils';

interface PriceDisplayProps {
  amount: number;
  currency?: string;
  period?: string;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export function PriceDisplay({
  amount,
  currency = '$',
  period,
  className,
  size = 'md'
}: PriceDisplayProps) {
  const sizes = {
    sm: {
      wrapper: 'text-base',
      currency: 'text-sm mt-1 mr-0.5',
      amount: 'text-xl font-semibold',
      period: 'text-xs ml-1 mb-0.5'
    },
    md: {
      wrapper: 'text-xl',
      currency: 'text-lg mt-1.5 mr-0.5',
      amount: 'text-3xl font-semibold',
      period: 'text-sm ml-1 mb-1'
    },
    lg: {
      wrapper: 'text-2xl',
      currency: 'text-xl mt-2 mr-1',
      amount: 'text-4xl sm:text-5xl font-bold',
      period: 'text-base ml-1 mb-1'
    }
  };
  
  const currentSize = sizes[size];
  
  return (
    <div className={cn('flex items-start font-display leading-none', currentSize.wrapper, className)}>
      <span className={cn('font-normal opacity-70', currentSize.currency)}>{currency}</span>
      <span className={currentSize.amount}>{amount}</span>
      {period && (
        <span className={cn('font-normal opacity-70 mt-auto', currentSize.period)}>/{period}</span>
      )}
    </div>
  );
}

export default PriceDisplay;
